import $ from 'jquery';
import {View} from 'backbone';

import _template from 'dashboard/forms/library-details-view.ejs';
import RestService from 'RestService.js'
import eventBus from 'EventBus.js';
import constants from 'Constants.js';
import NotificationService from 'NotificationService.js';

class LibraryDetailsView extends View {

    initialize(opts) {
        this.options = opts || {};
        this.template = _template;
        this.events={
            'click #importLibrary':'importLibrary', 
            'click #goToForms': 'goToForms',
            'click #goToLibraries': 'goToForms'
        };

        this.listenTo(this.model, 'change', this.render);
        return this;
    }

    goToForms(e) {
        e.preventDefault();
        e.stopPropagation();

        eventBus.trigger("loadFormsView");
    }

    importLibrary(ev) {
        let currentLibraryId = this.model.get('libraryId');
        RestService.importLibrary(currentLibraryId).then((response)=> {
            response.groupType = null;
            response.name  = response.formName;
            response.itemId = 'null-' + response.formId;
            response.msg = 'App "'+ response.formName + '", ID "' + response.formId + '" created.'; 
            console.log("Imported Library",response);
            eventBus.trigger(constants.IMPORT_LIBRARY_SUCCESS,response);
        }).catch((error)=>{
            NotificationService.error( 'The library is empty' );
            console.log(error);
        })
    }

    updatePages(evt){

        // Getting the description based on the Id of the Asset.
        // Need to verify if for each asset is related to a page.
        let id=$(evt.target).attr('id');
        let currentPages=this.model.get('libraryData').Pages.Page;
        if (currentPages instanceof Array) {
           let currentPageModel= this.model.get('libraryData').Pages.Page.filter((item)=> {
                return item._screenshotId === id;
            })[0];
            this.model.set('currentPage', currentPageModel);
        }
    }


    render() {
        this.$el.html(this.template(this.model.toJSON()));
        $("#imagesSection img").on('click', $.proxy(this.updatePages, this));
        this.delegateEvents();
        return this;
    }

    refresh(){
        eventBus.trigger(constants.EV_REFRESH_LIBRARY_DETAILS,this.model.get('libraryId'));
    }
}

export default LibraryDetailsView;